// eslint-disable-next-line no-shadow
export enum PromptsModalType {
	HOME_PROMPTS_MODAL = 'home_prompts_modal',
	MODEL_PAGE_PROMPTS_MODAL = 'model_page_prompts_modal',
	PROFILE_PAGE_PROMPTS_MODAL = 'profile_page_prompts_modal',
}
